import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useNotification } from "../../../hooks/notifications/useNotification";
import { PrintInfo } from "../../../interfaces/print";
import { print } from "../../../resources/print";
import { createPrintTaskInput } from "../../../evergis/core/scheduler/createPrintTask";

type PrintTask = {
  startPrint: VoidFunction;
  loading: boolean;
  printResult: {
    image: Blob;
    name: string;
    format: string;
  }[];
  error: Error;
};

export const usePrintTask = (printInfo: PrintInfo): PrintTask => {
  const { t } = useTranslation("print");
  const [printTask, { loading, data: printResult, error }] = print.use();

  const startPrint = useCallback(async () => {
    const printInput = await createPrintTaskInput(printInfo);

    await printTask({ input: printInput.templates });
  }, [printInfo]);

  useNotification(error, {
    title: t("exportError"),
    error: true,
  });

  return useMemo(() => ({ startPrint, loading, printResult, error }), [startPrint, loading, printResult, error]);
};
